import React, { useState } from "react";
import { useAppContext } from "../../../../context/AppContext";
import { Link, useNavigate } from "react-router-dom";
import AuthPageLayout from "../../components/AuthPageLayout";
import ButtonLoader from "../../../../components/ButtonLoader";
import Transition from "../../../../components/Transition";
import { LoginUser } from "../../network/api/LoginUser";
import { AnimatePresence } from "framer-motion";

export default function Login() {
    const { setIsLoggedIn, appData } = useAppContext();
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        email: "",
        password: "",
        app_id: appData.id,
    });

    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [errorStatus, setErrorStatus] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const handleChange = (e) => {
        setErrorMessage("");
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value,
        });

        if (errors[name]) {
            setErrors({ ...errors, [name]: null });
        }
    };

    const handleSubmit = async (e) => {
        setErrorMessage("");
        setIsLoading(true);
        e.preventDefault();

        const newErrors = {};
        if (!formData.email.trim()) newErrors.email = "Email is required";
        if (!formData.password.trim()) newErrors.password = "Password is required";

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setIsLoading(false);
            return;
        }

        // Proceed with form submission logic

        const response = await LoginUser(formData);
        
        if (response.status === "success") {
            setIsLoading(false);
            setErrorStatus(response.status);
            setErrorMessage(response.message);

            localStorage.setItem("userData", JSON.stringify(response.data));
            setIsLoggedIn(true);
        } else if (response.status === "pending") {
            setIsLoading(false);
            navigate("/welcome", { replace: true });

        } else {
            setIsLoading(false);
            setErrorStatus(response.status);
            setErrorMessage(response.message);
        }

    };
    return (
        <AuthPageLayout>
            <h4 className="text-center mb-4">Sign in, {appData.name}</h4>

            {!isLoading && errorMessage ? (
                <AnimatePresence mode="wait">
                    <Transition key={errorMessage} >
                        <div className={`alert alert-${errorStatus === "success" ? "success" : errorStatus === "pending" ? "warning" : "danger"} alert-dismissible alert-alt solid fade show`}>
                            <strong>{errorStatus === "success" ? "Success" : errorStatus === "pending" ? "Pending!" : "Error!"}</strong> {errorMessage}
                        </div>
                    </Transition>
                </AnimatePresence>
            ) : null}

            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label className="mb-1"><strong>Email</strong></label>
                    <input
                        type="email"
                        className={`form-control ${errors.email ? "is-invalid" : ""}`}
                        placeholder="admin@example.com"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                    />
                    {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                </div>

                <div className="mb-3 position-relative">
                    <label className="mb-1"><strong>Password</strong></label>
                    <input
                        type="password"
                        id="dz-password"
                        className={`form-control ${errors.password ? "is-invalid" : ""}`}
                        placeholder="********"
                        name="password"
                        value={formData.password}
                        onChange={handleChange}
                    />
                    {errors.password && <div className="invalid-feedback">{errors.password}</div>}
                    <span className="show-pass eye">
                        <i className="fa fa-eye-slash"></i>
                        <i className="fa fa-eye"></i>
                    </span>
                </div>

                <div className="row d-flex justify-content-between mt-4 mb-2">
                    <div className="mb-3">
                        <div className="form-check custom-checkbox ms-1">
                            <input type="checkbox" className="form-check-input" id="basic_checkbox_1" />
                            <label className="form-check-label" htmlFor="basic_checkbox_1">Remember my preference</label>
                        </div>
                    </div>
                    <div className="mb-3">
                        <Link to="/forgot-password">Forgot Password?</Link>
                    </div>
                </div>
                <div className="text-center mb-3">
                    <button type="submit" className="btn btn-primary btn-block" disabled={isLoading}>
                        {isLoading ? <ButtonLoader /> : "Sign In"}
                    </button>
                </div>
                <div className="text-center">
                    <Link to="/account-activation" type="button" className="btn btn-dark light btn-block">Account Activation</Link>
                </div>
            </form>
            <div className="new-account mt-3">
                <p>Don't have an account? <Link className="text-primary" to="/register">Sign up</Link></p>
            </div>

        </AuthPageLayout>
    );

}
